import React from "react";
import Logo from "../assets/img/logo.png";
import "./style.css";
const Footer = () => {
  return (
    <footer class="bg-[#f5f5f5] dark:bg-gray-900">
      <div class="mx-auto w-full max-w-screen-xl pt-8 m-auto">
        <div class="grid grid-cols-2 gap-8 px-4 py-6 lg:py-8 md:grid-cols-4">
          <div>
            <h2 class="mb-6 text-sm font-medium text-gray-900 uppercase dark:text-white">
              About Us
            </h2>
            <ul class="text-[#525252] dark:text-gray-400 font-medium">
              <li class="my-2">
                <p className="mb-4 font-medium">
                  We look into new millennium now which is replete with great
                  challenges and golden opportunities of entirely different
                  order of magnitude nature & character at global level.
                </p>
                <div class="flex mt-4 sm:justify-start md:mt-0 space-x-5 rtl:space-x-reverse">
                  <a
                    href="https://www.facebook.com/share/193ApoZWBz/?mibextid=wwXIfr" target="_blank"
                    class="text-[#5f5f5f] hover:text-gray-900 dark:hover:text-white"
                  >
                    <svg
                      class="w-4 h-4"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 8 19"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="sr-only">Facebook page</span>
                  </a>
                  <a
                    href="#" target="_blank"
                    class="text-[#5f5f5f] hover:text-gray-900 dark:hover:text-white"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M20.67 3H17.7l-4.51 5.78L8.17 3H3.01l6.52 9.36L3 21h3.03l4.85-6.23L16.3 21h5.15l-6.88-9.87L20.67 3z" />
                    </svg>
                    <span class="sr-only">Discord community</span>
                  </a>
                  <a
                    href="http://linkedin.com/in/mahesh-chaurasia-b34abb231" target="_blank"
                    class="text-[#5f5f5f] hover:text-gray-900 dark:hover:text-white"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M4.98 3.5C4.98 4.6 4.1 5.5 3 5.5S1.02 4.6 1.02 3.5 1.9 1.5 3 1.5s1.98.9 1.98 2zM.5 6.75h5V22h-5V6.75zm7.5 0h4.78v2.08h.07c.66-1.25 2.28-2.58 4.7-2.58 5.02 0 5.95 3.3 5.95 7.6V22h-5V14.1c0-1.9-.03-4.35-2.65-4.35-2.65 0-3.06 2.07-3.06 4.2V22h-5V6.75z" />
                    </svg>

                    <span class="sr-only">Twitter page</span>
                  </a>
                  <a
                    href="#" target="_blank"
                    class="text-[#5f5f5f] hover:text-gray-900 dark:hover:text-white"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M7.75 2h8.5A5.76 5.76 0 0 1 22 7.75v8.5A5.76 5.76 0 0 1 16.25 22h-8.5A5.76 5.76 0 0 1 2 16.25v-8.5A5.76 5.76 0 0 1 7.75 2zm0 1.5A4.26 4.26 0 0 0 3.5 7.75v8.5A4.26 4.26 0 0 0 7.75 20.5h8.5A4.26 4.26 0 0 0 20.5 16.25v-8.5A4.26 4.26 0 0 0 16.25 3.5h-8.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm4.75-.88a1.12 1.12 0 1 1 0 2.25 1.12 1.12 0 0 1 0-2.25z" />
                    </svg>
                    <span class="sr-only">GitHub account</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <h2 class="mb-6 text-sm font-medium text-gray-900 uppercase dark:text-white">
              Quick Links
            </h2>
            <ul class="text-[#525252] dark:text-gray-400 font-medium">
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/about-us/" class="hover:underline">
                  About Us
                </a>
              </li>
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/clients/" class="hover:underline">
                  Clients
                </a>
              </li>
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/contact-us/" class="hover:underline">
                  Contact Us
                </a>
              </li>
              <li class="py-[4px]">
                <a href="#" class="hover:underline">
                  Quality
                </a>
              </li>
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/customers/" class="hover:underline">
                  Customers
                </a>
              </li>
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/terms-conditions/" class="hover:underline">
                  Terms & Conditions
                </a>
              </li>
              <li class="py-[4px]">
                <a href="https://supersprings.co.in/index.php/privacy-policy-2/" class="hover:underline">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h2 class="mb-6 text-sm font-medium text-gray-900 uppercase dark:text-white">
              Products
            </h2>
            <ul class="text-[#525252] dark:text-gray-400 font-medium">
              <li class="mb-4">
                <a href="https://supersprings.co.in/portal/product" class="hover:underline">
                  DIN-472-FLAT CIRCLIP
                </a>
              </li>
              <li class="mb-4">
                <a href="https://supersprings.co.in/index.php/products/" class="hover:underline">
                  COMPRESSION SPRINGS
                </a>
              </li>
              <li class="mb-4">
                <a href="https://supersprings.co.in/index.php/products/" class="hover:underline">
                  FLATE WIRE CIRCLIP
                </a>
              </li>
              <li class="mb-4">
                <a href="https://supersprings.co.in/index.php/products/" class="hover:underline">
                  PLATE EXPANDER
                </a>
              </li>
              <li class="mb-4">
                <a href="https://supersprings.co.in/index.php/products/" class="hover:underline">
                  SERPENTINE EXPANDER
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h2 class="mb-6 text-sm font-medium text-gray-900 uppercase dark:text-white">
              CONTACT
            </h2>
            <ul class="text-[#525252] dark:text-gray-400 font-medium">
              <li class="mb-4">
                <div>
                  <strong>Super Springs</strong>
                  <strong>Plaint 1:</strong>
                  <div>D-235, Sector-10, Noida (UP) Pin Code: 201301 INDIA</div>
                  <div>
                    <strong>Plant 2:</strong>
                    <p>B-105 Sector-65 Noida (UP) Pin Code: 201307 INDIA</p>
                  </div>
                </div>
                <div className="mt-5">
                  <p>
                    <strong>Phone No.: </strong>
                    <a href="tel:+91 1204337718">+91 1204337718</a>
                  </p>
                  <p>
                    <strong>Mobile No.: </strong>
                    <a href="tel:+91 98104 60594">+91 98104 60594</a>,{" "}
                    <a href="tel:+91 9810117900">+91 98104 60594</a>
                  </p>
                  <p>
                    <strong>Email: </strong>
                    <a href="info@supersprings.co.in">info@supersprings.co.in</a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="px-4 py-6 bg-gray-100 dark:bg-gray-700 md:flex md:items-center md:justify-center">
          <span class="text-sm text-gray-500 dark:text-gray-300 sm:text-center">
            © 2024 Super Springs. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
